var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarretLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-id": "caret-right",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333 15.9999C9.333 15.6586 9.46367 15.3173 9.72367 15.0573L17.7237 7.05726C18.245 6.53593 19.0877 6.53593 19.609 7.05726C20.1303 7.57859 20.1303 8.42126 19.609 8.94259L12.5517 15.9999L19.609 23.0573C20.1303 23.5786 20.1303 24.4213 19.609 24.9426C19.0877 25.4639 18.245 25.4639 17.7237 24.9426L9.72367 16.9426C9.46367 16.6826 9.333 16.3413 9.333 15.9999Z",
    fill: "#29173B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarretLeft);
export default __webpack_public_path__ + "static/media/carret-left.14a072f3058e85619cd93934a30c84b1.svg";
export { ForwardRef as ReactComponent };